export const journeyPlannerCs = {
  navigationLabel: 'Spojení',
  navigation: 'Hlavní navigace',
  map: 'Mapa',
  vehicles: 'Aktivní vozy',
  eyebrow: 'Plánovač cesty',
  title: 'Najít nejlepší spojení',
  description: 'Porovnejte nejrychlejší cestu s variantami s méně přestupy. Počítáme i chůzi, čekání a čas na přestup.',
  from: 'Odkud',
  to: 'Kam',
  fromPlaceholder: 'Zastávka nebo místo odjezdu',
  toPlaceholder: 'Zastávka nebo cíl',
  via: 'Přes (volitelné)',
  viaPosition: 'Průjezdní zastávka {position}',
  viaPlaceholder: 'Vyberte průjezdní zastávku',
  addVia: 'Přidat průjezdní zastávku',
  removeVia: 'Odebrat průjezdní zastávku {position}',
  moveViaUp: 'Posunout průjezdní zastávku {position} nahoru',
  moveViaDown: 'Posunout průjezdní zastávku {position} dolů',
  viaLimit: 'Lze zadat nejvýše {count} průjezdních zastávek.',
  viaSummary: 'Přes:',
  searchHint: 'Začněte psát alespoň 2 znaky a vyberte místo ze seznamu.',
  savedSearchesButton: 'Uložená spojení',
  openSavedSearches: 'Otevřít uložená spojení, počet položek: {count}',
  closeSavedSearches: 'Zavřít uložená spojení',
  savedSearches: 'Oblíbená spojení a historie',
  savedLocalOnly: 'Ukládají se jen v tomto prohlížeči, ne do účtu ani na server. Po výběru se spojení vyhledá znovu pro aktuální čas.',
  currentSearch: 'Aktuální zadání',
  currentSearchEmpty: 'Nejdřív vyberte odkud a kam.',
  addCurrentFavorite: 'Uložit do oblíbených',
  removeCurrentFavorite: 'Odebrat z oblíbených',
  currentLocationNotSaved: 'Hledání s aktuální polohou kvůli soukromí neukládáme.',
  savedSearchCategories: 'Kategorie uložených spojení',
  favorites: 'Oblíbené',
  searchHistory: 'Historie hledání',
  noFavorites: 'Zatím žádná oblíbená spojení',
  noFavoritesHint: 'Nastavte cestu a uložte ji hvězdičkou. Příště ji vyhledáte jediným klepnutím.',
  noSearchHistory: 'Historie je zatím prázdná',
  noSearchHistoryHint: 'Úspěšná hledání se zde objeví automaticky.',
  replayForNow: 'Výběrem spojení hledáte znovu pro aktuální čas.',
  savedVia: 'Přes: {places}',
  removeFavorite: 'Odebrat oblíbené spojení {route}',
  clearHistory: 'Vymazat historii',
  removeHistoryEntry: 'Odebrat z historie spojení {route}',
  noPlaces: 'Žádné odpovídající místo jsme nenašli.',
  placeLoadError: 'Místa se nepodařilo načíst.',
  useLocation: 'Použít aktuální polohu',
  currentLocation: 'Moje poloha',
  locating: 'Zjišťuji polohu…',
  locationDenied: 'Přístup k poloze není povolený.',
  locationUnavailable: 'Aktuální polohu se nepodařilo zjistit.',
  swap: 'Prohodit odkud a kam',
  leave: 'Odjezd',
  leaveNow: 'Teď',
  leaveAt: 'V určený čas',
  dateTime: 'Datum a čas odjezdu',
  strategy: 'Typ cesty',
  standard: 'Standardní',
  standardDescription: 'Běžné spojení seřazené podle rychlosti nebo počtu přestupů.',
  seatChance: 'Vyšší šance si sednout',
  seatChanceDescription: 'Upřednostní dlouhý úsek s nástupem co nejblíže začátku linky. Cesta může být nejvýše o 30 minut, 1,75× delší a s jedním nástupem navíc oproti nejrychlejší.',
  scenic: 'Šototrasa',
  scenicDescription: 'Hledá nejdelší nalezenou trasu bez opakování stejného úseku ani opačným směrem. Nejvýše 4 hodiny a 3 výsledky; počet přestupů určíte v dalších možnostech. Končí při prvním dosažení cíle a výsledek je orientační.',
  preference: 'Upřednostnit',
  fastest: 'Nejrychlejší',
  fewestTransfers: 'Nejméně přestupů',
  additionalOptions: 'Další možnosti',
  additionalOptionsDefault: 'Volitelné',
  additionalOptionsActive: 'Aktivní omezení: {count}',
  requirements: 'Další požadavky',
  maxTransfers: 'Nejvyšší počet přestupů',
  maxTransfersDescription: 'Omezí počet změn vozidla nezávisle na ostatních volbách. Nastavení zůstane zachované i při volbě Bez přestupu.',
  maxTransfersNone: 'Bez přestupu (0)',
  maxTransfersOne: 'Nejvýše 1 přestup',
  maxTransfersFew: 'Nejvýše {count} přestupy',
  maxTransfersMany: 'Nejvýše {count} přestupů',
  allowedRoutes: 'Povolené linky',
  allowedRoutesDescription: 'Každý úsek veřejnou dopravou smí použít jen některou z vybraných linek. Bez výběru jsou povoleny všechny linky.',
  selectedRoutes: 'Vybrané povolené linky',
  selectedRoutesCount: 'Vybráno: {count}',
  removeAllowedRoute: 'Odebrat povolenou linku {route}',
  routesLoading: 'Načítám seznam linek…',
  routesLoadError: 'Seznam linek se nepodařilo načíst. Spojení můžete dál hledat bez omezení linek.',
  routesEmpty: 'Pro tuto síť nejsou k dispozici žádné linky.',
  searchRoutes: 'Vyhledat linku',
  searchRoutesPlaceholder: 'Číslo, název nebo druh dopravy',
  noMatchingRoutes: 'Žádná linka neodpovídá hledání.',
  allowedRoutesLimit: 'Lze vybrat nejvýše {count} linek.',
  savedAllowedRoutes: 'Linky: {routes}',
  avoidCityCenter: 'Vyhnout se centru',
  avoidCityCenterDescription: 'Spojení nesmí projet přes I. P. Pavlova, Karlovo náměstí, Národní třídu, Václavské náměstí, Můstek ani Muzeum.',
  avoidCityCenterUnavailable: 'Tuto volbu nelze použít, protože výchozí, cílová nebo průjezdní zastávka leží v centru.',
  surfaceOnly: 'Pouze povrchová doprava',
  surfaceOnlyDescription: 'Bez metra; povoleny zůstávají všechny povrchové druhy dopravy.',
  railOnly: 'Pouze kolejová doprava',
  railOnlyDescription: 'Pouze tramvaje, metro, vlaky a lanovky.',
  directOnly: 'Bez přestupu',
  directOnlyDescription: 'Pěšky k nástupní zastávce, jedním vozidlem a pěšky od výstupní zastávky. Pokud takové spojení neexistuje, nenabídneme náhradní variantu.',
  combinedModeFilters: 'Při obou volbách se použijí jen tramvaje, vlaky a lanovky.',
  search: 'Vyhledat spojení',
  missingPlaces: 'Vyberte výchozí i cílové místo.',
  invalidVia: 'Vyberte každou průjezdní zastávku z nabídky, nebo neúplný řádek odeberte.',
  invalidTime: 'Zadejte platné datum a čas odjezdu.',
  loading: 'Hledám nejlepší spojení…',
  loadError: 'Spojení se teď nepodařilo vyhledat.',
  empty: 'Pro zadaný čas jsme žádné spojení nenašli.',
  emptyHint: 'Zkuste jiný čas nebo jiné výchozí a cílové místo.',
  results: 'Nalezená spojení',
  resultCount: '{count} variant',
  profileIncomplete: 'Zobrazeny jsou doporučené varianty; další vhodná spojení mohou existovat.',
  approximateScenic: 'Šototrasa je nejdelší nalezená během omezeného výpočtu, nikoli zaručeně absolutně nejdelší.',
  loadMore: 'Načíst další',
  loadingMore: 'Načítám další spojení…',
  loadMoreError: 'Další spojení se teď nepodařilo načíst. Dosavadní výsledky zůstávají zobrazené.',
  retryMore: 'Zkusit načíst znovu',
  moreLoaded: 'Výsledky byly doplněny. Celkem je zobrazeno {count} spojení.',
  fastestBadge: 'Nejrychlejší',
  fewestTransfersBadge: 'Nejméně přestupů',
  duration: '{count} min',
  direct: 'Bez přestupu',
  transfers: '{count} přestupů',
  walking: '{count} min pěšky',
  waiting: '{count} min čekání',
  seatPriorityMetric: 'Úsek s vyšší šancí na místo: {count} zastávek · nástup na {position}. zastávce spoje',
  scenicDistance: 'Ve vozech: {distance}',
  details: 'Podrobnosti cesty',
  hideDetails: 'Skrýt podrobnosti',
  openFullDetail: 'Detail a mapa',
  detailEyebrow: 'Detail spojení',
  closeDetail: 'Zavřít detail spojení',
  usedRoutes: 'Použité linky',
  timeline: 'Průběh cesty',
  legCount: '{count} úseků',
  routeMap: 'Mapa celé cesty',
  routeMapLabel: 'Interaktivní mapa cesty z místa {origin} do místa {destination}',
  tripRouteMap: 'Mapa spoje linky {route}',
  tripRouteMapLabel: 'Interaktivní mapa spoje linky {route} směrem {headsign}',
  approximateTripRoute: 'Přesný průběh spoje není dostupný. Mapa zobrazuje pouze orientační spojení krajních zastávek.',
  simplifiedTripRoute: 'Trasa spoje je pro rychlé zobrazení mapy mírně zjednodušená.',
  approximateSelectedTripLeg: 'Vybraný úsek nemá přesnou geometrii a je zvýrazněný orientační přímou čarou.',
  openTripDetail: 'Otevřít detail spoje',
  backToJourney: 'Zpět na celé spojení',
  tripDetailLoading: 'Načítám zastávky, časy a trasu spoje…',
  tripDetailError: 'Detail tohoto spoje se teď nepodařilo načíst. Celé spojení zůstává dostupné.',
  approximateRoute: 'Některé pěší nebo chybějící úseky jsou zobrazené orientačně přímou čarou.',
  mapBackgroundUnavailable: 'Mapový podklad nebo interaktivní mapa nejsou dostupné. Průběh cesty zůstává v seznamu úseků.',
  mapLegend: 'Legenda mapy cesty',
  walkingLegend: 'Pěší přesun',
  accessWalk: 'Pěšky k zastávce',
  transferWalk: 'Přesun při přestupu',
  wait: 'Čekání na spoj',
  transit: 'Jízda veřejnou dopravou',
  egressWalk: 'Pěšky do cíle',
  walkDistance: '{distance} m · {minutes} min',
  minimumTransferDuration: 'Minimální čas na přestup: {count} min',
  stayOnBoard: 'Zůstaňte ve voze',
  guaranteedConnection: 'Garantovaný přestup',
  legDuration: '{count} min',
  toward: 'směr {headsign}',
  intermediateStops: '{count} mezizastávek',
  realtime: 'Aktuální časy',
  scheduled: 'Podle jízdního řádu',
  platform: 'nástupiště {platform}',
}

export const journeyPlannerEn = {
  navigationLabel: 'Journey planner',
  navigation: 'Main navigation',
  map: 'Map',
  vehicles: 'Active vehicles',
  eyebrow: 'Journey planner',
  title: 'Find the best connection',
  description: 'Compare the fastest journey with options that use fewer transfers. Walking, waiting and transfer time are included.',
  from: 'From',
  to: 'To',
  fromPlaceholder: 'Stop or departure place',
  toPlaceholder: 'Stop or destination',
  via: 'Via (optional)',
  viaPosition: 'Via stop {position}',
  viaPlaceholder: 'Choose a via stop',
  addVia: 'Add via stop',
  removeVia: 'Remove via stop {position}',
  moveViaUp: 'Move via stop {position} up',
  moveViaDown: 'Move via stop {position} down',
  viaLimit: 'You can add up to {count} via stops.',
  viaSummary: 'Via:',
  searchHint: 'Type at least 2 characters and choose a place from the list.',
  savedSearchesButton: 'Saved journeys',
  openSavedSearches: 'Open saved journeys, {count} items',
  closeSavedSearches: 'Close saved journeys',
  savedSearches: 'Favourite journeys and history',
  savedLocalOnly: 'Saved only in this browser, not to your account or the server. Selecting one searches again for the current time.',
  currentSearch: 'Current search',
  currentSearchEmpty: 'Choose an origin and destination first.',
  addCurrentFavorite: 'Add to favourites',
  removeCurrentFavorite: 'Remove from favourites',
  currentLocationNotSaved: 'Searches using your current location are not saved for privacy.',
  savedSearchCategories: 'Saved journey categories',
  favorites: 'Favourites',
  searchHistory: 'Search history',
  noFavorites: 'No favourite journeys yet',
  noFavoritesHint: 'Set up a journey and save it with the star. You can search it again with one tap.',
  noSearchHistory: 'Your history is empty',
  noSearchHistoryHint: 'Successful searches will appear here automatically.',
  replayForNow: 'Selecting a journey searches again for the current time.',
  savedVia: 'Via: {places}',
  removeFavorite: 'Remove favourite journey {route}',
  clearHistory: 'Clear history',
  removeHistoryEntry: 'Remove journey {route} from history',
  noPlaces: 'No matching place was found.',
  placeLoadError: 'Places could not be loaded.',
  useLocation: 'Use current location',
  currentLocation: 'My location',
  locating: 'Finding your location…',
  locationDenied: 'Location access is not allowed.',
  locationUnavailable: 'Your current location could not be determined.',
  swap: 'Swap origin and destination',
  leave: 'Departure',
  leaveNow: 'Now',
  leaveAt: 'At a chosen time',
  dateTime: 'Departure date and time',
  strategy: 'Journey type',
  standard: 'Standard',
  standardDescription: 'Regular connections sorted by speed or number of transfers.',
  seatChance: 'Better chance of a seat',
  seatChanceDescription: 'Prefers a long ride boarded as close as possible to the start of the service. The journey may be at most 30 minutes and 1.75× longer, with one extra boarding, than the fastest option.',
  scenic: 'Scenic ride',
  scenicDescription: 'Finds the longest route discovered without repeating the same segment in either direction. Limited to 4 hours and 3 results; choose the transfer limit in additional options. It ends on first reaching the destination and the result is approximate.',
  preference: 'Prefer',
  fastest: 'Fastest',
  fewestTransfers: 'Fewest transfers',
  additionalOptions: 'Additional options',
  additionalOptionsDefault: 'Optional',
  additionalOptionsActive: 'Active constraints: {count}',
  requirements: 'Additional requirements',
  maxTransfers: 'Maximum transfers',
  maxTransfersDescription: 'Limits vehicle changes independently of the other options. This setting is preserved while Direct only is enabled.',
  maxTransfersNone: 'Direct only (0)',
  maxTransfersOne: 'At most 1 transfer',
  maxTransfersFew: 'At most {count} transfers',
  maxTransfersMany: 'At most {count} transfers',
  allowedRoutes: 'Allowed routes',
  allowedRoutesDescription: 'Every public-transport leg may use only one of the selected routes. With no selection, all routes are allowed.',
  selectedRoutes: 'Selected allowed routes',
  selectedRoutesCount: '{count} selected',
  removeAllowedRoute: 'Remove allowed route {route}',
  routesLoading: 'Loading routes…',
  routesLoadError: 'Routes could not be loaded. You can still search without restricting routes.',
  routesEmpty: 'No routes are available for this network.',
  searchRoutes: 'Search routes',
  searchRoutesPlaceholder: 'Number, name or transport mode',
  noMatchingRoutes: 'No route matches your search.',
  allowedRoutesLimit: 'You can select up to {count} routes.',
  savedAllowedRoutes: 'Routes: {routes}',
  avoidCityCenter: 'Avoid the city centre',
  avoidCityCenterDescription: 'The connection must not pass through I. P. Pavlova, Karlovo náměstí, Národní třída, Václavské náměstí, Můstek or Muzeum.',
  avoidCityCenterUnavailable: 'This option is unavailable because the origin, destination or a via stop is in the city centre.',
  surfaceOnly: 'Surface transport only',
  surfaceOnlyDescription: 'No metro; all surface transport modes remain available.',
  railOnly: 'Rail transport only',
  railOnlyDescription: 'Trams, metro, trains and funiculars only.',
  directOnly: 'Direct only',
  directOnlyDescription: 'Walk to the boarding stop, ride one vehicle, then walk from the alighting stop. If no such connection exists, no fallback is offered.',
  combinedModeFilters: 'When both options are selected, only trams, trains and funiculars are used.',
  search: 'Find connections',
  missingPlaces: 'Choose both an origin and a destination.',
  invalidVia: 'Choose every via stop from the suggestions, or remove the incomplete row.',
  invalidTime: 'Enter a valid departure date and time.',
  loading: 'Finding the best connections…',
  loadError: 'Connections could not be searched right now.',
  empty: 'No connection was found for the selected time.',
  emptyHint: 'Try another time, origin or destination.',
  results: 'Connections found',
  resultCount: '{count} options',
  profileIncomplete: 'Recommended options are shown; other suitable connections may exist.',
  approximateScenic: 'This is the longest route found during a bounded search, not a guaranteed absolute maximum.',
  loadMore: 'Load more',
  loadingMore: 'Loading more connections…',
  loadMoreError: 'More connections could not be loaded. The existing results remain available.',
  retryMore: 'Try loading again',
  moreLoaded: 'More results were loaded. {count} connections are now shown.',
  fastestBadge: 'Fastest',
  fewestTransfersBadge: 'Fewest transfers',
  duration: '{count} min',
  direct: 'Direct',
  transfers: '{count} transfers',
  walking: '{count} min walking',
  waiting: '{count} min waiting',
  seatPriorityMetric: 'Higher-seat-chance ride: {count} stops · board at service stop {position}',
  scenicDistance: 'On board: {distance}',
  details: 'Journey details',
  hideDetails: 'Hide details',
  openFullDetail: 'Details and map',
  detailEyebrow: 'Journey details',
  closeDetail: 'Close journey details',
  usedRoutes: 'Routes used',
  timeline: 'Journey timeline',
  legCount: '{count} legs',
  routeMap: 'Whole journey map',
  routeMapLabel: 'Interactive journey map from {origin} to {destination}',
  tripRouteMap: 'Route {route} service map',
  tripRouteMapLabel: 'Interactive map of route {route} towards {headsign}',
  approximateTripRoute: 'The exact service shape is unavailable. The map only shows an approximate line between the first and last stop.',
  simplifiedTripRoute: 'The service shape is slightly simplified for fast map rendering.',
  approximateSelectedTripLeg: 'The selected leg has no exact geometry and is highlighted with an approximate straight line.',
  openTripDetail: 'Open service details',
  backToJourney: 'Back to the whole journey',
  tripDetailLoading: 'Loading service stops, times and route…',
  tripDetailError: 'This service detail could not be loaded. The whole journey remains available.',
  approximateRoute: 'Some walking or unavailable sections are shown approximately as a straight line.',
  mapBackgroundUnavailable: 'The map background or interactive map is unavailable. The journey remains available in the leg list.',
  mapLegend: 'Journey map legend',
  walkingLegend: 'Walking section',
  accessWalk: 'Walk to the stop',
  transferWalk: 'Walk during transfer',
  wait: 'Wait for service',
  transit: 'Public transport ride',
  egressWalk: 'Walk to destination',
  walkDistance: '{distance} m · {minutes} min',
  minimumTransferDuration: 'Minimum transfer time: {count} min',
  stayOnBoard: 'Stay on board',
  guaranteedConnection: 'Guaranteed connection',
  legDuration: '{count} min',
  toward: 'towards {headsign}',
  intermediateStops: '{count} intermediate stops',
  realtime: 'Live times',
  scheduled: 'Timetable times',
  platform: 'platform {platform}',
}
